import { MentionUser } from "designSystem/components/editor/tributeService";
import React from "react";

export interface UserQuery {
    input?: string;
}

export interface IUseUserProvider<U> {
	/**
	 * Get the user by search
	 */
	search(query: UserQuery): Promise<U[]> ;

	/**
	 * Get user search with cache
	 */
	searchWithCache(query: UserQuery): Promise<U[]> ;

	/**
	 * clear user search cache
	 */
	clearSearchCache();
}

export const search = async (query: UserQuery): Promise<MentionUser[]> => {
	return Promise.resolve([]);	
};

export const searchWithCache = async (query: UserQuery): Promise<MentionUser[]> => {
	return Promise.resolve([]);	
};

export const clearSearchCache = (): void => {};

// create context with default use User provider
const userProvider: IUseUserProvider<MentionUser> = {
	search,
	searchWithCache,
	clearSearchCache,
};

export const UserContext = React.createContext(userProvider);

/**
 * Hook to use user provider
 */
export function useUserProvider(): IUseUserProvider<MentionUser> {
	return React.useContext(UserContext);
}
